// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/config/wifi.ts
// 🔧 PURPOSE: La rete WiFi degli appartamenti: una sola per tutte le case,
//             senza API (il clima del channel manager dice solo il nome).
//             Stava dentro MyStay; adesso la usa anche la Home (azione
//             rapida "Copia password").
//
//             Chi la mostra decide QUANDO: solo a check-in online fatto,
//             dal giorno di arrivo e fino al giorno della partenza (vedi
//             MyStay e lib/homeState). Il nascondiglio e' solo nello
//             schermo: la password sta comunque nel pacchetto JS.
// ============================================

export const WIFI_SSID = 'Nonna Vittoria Guest';
export const WIFI_PASSWORD = 'noNNa2022viTtoria!';
/** Il QR che la fotocamera di iPhone e Android apre come "Connetti a …". */
export const WIFI_QR_STRING = `WIFI:T:WPA;S:${WIFI_SSID};P:${WIFI_PASSWORD};;`;

/** Copia la password negli appunti: true se e' andata. */
export async function copyWifiPassword(): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(WIFI_PASSWORD);
    return true;
  } catch (err) {
    console.error('Failed to copy WiFi password:', err);
    return false;
  }
}

export type WifiPlatform = 'ios' | 'android' | 'other';

/** Il sistema del telefono, per scegliere come aiutare a collegarsi. */
export function wifiPlatform(): WifiPlatform {
  const userAgent = (typeof navigator !== 'undefined' ? navigator.userAgent : '').toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) return 'ios';
  if (/android/.test(userAgent)) return 'android';
  return 'other';
}

/**
 * Android: apre le impostazioni WiFi, mezzo secondo dopo la copia della
 * password. iOS non lo permette (lì si mostra il QR), sul computer basta
 * incollare.
 */
export function openAndroidWifiSettings(): void {
  setTimeout(() => {
    try {
      window.location.href = 'intent:#Intent;action=android.settings.WIFI_SETTINGS;end';
    } catch {
      // Niente impostazioni: la password e' gia' negli appunti.
    }
  }, 500);
}
